import {
    FormElement,
    IFormElementBusinessLogic,
    createFormElement,
} from '@vfde-brix/ws10/form-element';
import { IValidation } from '@vfde-brix/ws10/validation';

/**
 * mount and return form element with the given validation rules
 */
export const mountFormElement = (containerElementId: string, validation: IValidation[]): FormElement | null => {
    const containerElement = document.getElementById(containerElementId);

    const props: IFormElementBusinessLogic = {
        validation,
        onChange: () => {}, // onChange is mandatory in brix
    };

    return containerElement && createFormElement(containerElement, props);
};
